<template>
  <div class="root">
    <VueConfirmDialog :parent="_uid" />
    <div v-if="referralLink" class="root-container">
      <div class="container">
        <div v-if="!isAuth" class="login-container">
          <p class="login-title">Log In</p>
          <p class="login-message"> Access the RUX App to make packing lists and track what you pack.</p>
          <button class="login-button" @click="goToLogin">Log In</button>
          <div class="dividing-line"></div>
        </div>
        <p class="refer-title">Refer a Friend</p>
        <p class="refer-sub-title">Give 10% Off <span class="right-symbol">&#10132;</span> Get 10% Credit</p>
        <button class="refer-button" @click="goToReferralLink">USE YOUR DISCOUNT</button>
        <p>
          <a class="refer-link" :href="referralLink" target="_blank">CODE: {{ sanitizedReferralLink }}</a>
          <button @click="copyToClipboard" class="copy-button">
            <span class="material-symbols-outlined copy-icon">file_copy</span>
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueConfirmDialog from '../ConfirmDialog/vue-confirm-dialog.vue'
export default {
  name: 'ReferAFriend',
  components: {
    VueConfirmDialog
  },
  data() {
    return {
      referralLink: this.$route.params.referralLink
    }
  },
  computed: {
    ...mapState({ isAuth: (state) => state.auth.isAuth }),
    sanitizedReferralLink() {
      const prefix = 'https://'
      return this.referralLink.startsWith(prefix) ? this.referralLink.slice(prefix.length) : this.referralLink
    }
  },
  methods: {
    goToReferralLink() {
      window.location.href = this.referralLink
    },
    goToLogin() {
      this.$router.push('/login')
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.referralLink)
      this.$confirm({
        message: 'Copied to clipboard!',
        buttons: [
          {
            text: 'OK',
          },
        ],
        parent: this._uid,
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.root-container {
  margin-top: 50px;
}
.container {
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-left: 40px;
  padding-right: 40px;
}
.login-container {
  gap: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.login-title {
  font-family: "Neue Roman";
  font-size: 2.35em;
  text-align: center;
  margin-bottom: 0px;
}
.login-message {
  font-family: "Neue Roman";
  text-align: center;
  font-size: 1.0em;
  line-height: 1em;
  font-weight: light;
  width: 80%;
  color: #0C1B2F;
}
.login-button {
  width: 110px;
  height: 35px;
  font-size: 1em;
}
.dividing-line {
  border-top: 1px solid #c0c0c0;
  margin: 30px 0px 30px 0px;
  width: 100%;
}
.refer-title {
  font-family: "Neue Roman";
  font-size: 2.35em;
  text-align: center;
  margin-bottom: -15px;
}
.refer-sub-title {
  margin-bottom: 20px;
  font-size: 1.10em;
}
.right-symbol {
  padding: 0 5px 0 5px;
}
.refer-link {
  color: #0C1B2F;
}
.refer-button {
  width: 208px;
  height: 35px;
  font-size: 1em;
  margin-bottom: 10px;
}
.copy-button {
  background: none;
  border: none;
  cursor: pointer;
  padding-left: 2px;
  width: 5px;
  height: 25px;
  transition: transform 0.2s ease-in-out;
}
.copy-button:active {
  transform: scale(1.2);
}
.copy-button:focus {
  outline: none;
}
.copy-button:focus-visible {
  outline: none;
}
.copy-icon {
  color: #f15d35;
  font-size: 20px;
  position: relative;
  top: 3px;
  padding-left: 5px;
}
</style>